import { queryOptions } from '@tanstack/react-query'
import wretch from 'wretch'

import { API_ENDPOINTS } from '@/lib/constants/api'

import { type ResCheckAuthenticatedToken } from './types'

export const checkAuthenticatedTokenQuery = (token?: string) =>
  queryOptions({
    queryKey: [API_ENDPOINTS.auth.business.authenticated.index, token],
    queryFn: (): Promise<ResCheckAuthenticatedToken> =>
      wretch(`${import.meta.env.VITE_API_BASE_URL ?? ''}${API_ENDPOINTS.auth.business.authenticated.index}`)
        .headers({
          Authorization: token ?? '',
        })
        .get()
        .json(),
    enabled: !!token,
    retry: 0,
    throwOnError: true,
  })
